import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/danielwong/facility-calcom/cal2/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
